/**
 * Created by fers on 10.05.16.
 */
import * as Permission from '../../../common/util/Permission';

import * as Relation from './DataSourceRelationAdd.react.js';
import * as Match from './DataSourceMatchAdd.react.js';
import * as Query from './DataSourceQueryAdd.react.js';
import * as ManualQuery from './DataSourceManualQueryAdd.react.js';
import * as SearchAction from './DataSourceSearchActionAdd.react';
import * as CompanySearch from './DataSourceCompanySearchAdd.react';
import * as BrowserPermission from '../../BrowserPermission';

/**
 * Don't forget to add all handlers to Relay fragment in DataSourcesToAdd.react.js
 */
let handlers = [
    Relation,
    Match,
    Query,
    ManualQuery,
    SearchAction
];

let permHandlers = [
	CompanySearch
];

let handlerMap = {};

for (let handler of handlers) {
    handlerMap[handler.handlerName] = {
        value: handler,
        handler: handler.default,
        configHandler: handler.config,
    };
}

export default handlerMap;

export function hasUIHandlerConfig(handlerKey, permObject) {
    if (handlerMap[handlerKey] && handlerMap[handlerKey].value.config) {
        return true;
    }

	if (permObject && BrowserPermission.hasPermission(Permission.PERM_EDIT_CHANNEL_DEF, permObject)
		&& permHandlers[handlerKey] && permHandlers[handlerKey].value.config
	) {
		return true;
	}

    return false;
}
